//#region src/core/ui/buffering-indicator/data.ts
const BufferingIndicatorDataAttrs = { 
/** Present when the buffering indicator is visible (after delay). */
visible: "data-visible" };
//#endregion
export { BufferingIndicatorDataAttrs };

//# sourceMappingURL=data.js.map